module.exports = __webpack_public_path__ + "img/packages_01.10472d17.jpg";